import {
  Alert,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";
import { useMemo, useState } from "react";
import { timezones } from "../../../pages/configuracoes/easyLogs/fusoHorarios";

interface ConfigGeralProps {
  config: EasyReportConfig | undefined;
  setConfig: (config: EasyReportConfig) => void;
  setHasChanges: (value: boolean) => void;
}

export function ConfigGeral({
  config,
  setConfig,
  setHasChanges,
}: ConfigGeralProps) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const configuracao = useMemo(
    () => config?.configuracoes,
    [config?.configuracoes],
  );

  const [changes, setChanges] = useState(false);
  const [timezone, setTimezone] = useState(
    configuracao?.timeZone || timezones[0].query,
  );

  const handleIntervalChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = Number(event.target.value);
    if (config) {
      setConfig({
        ...config,
        configuracoes: { ...configuracao, interval: value },
      });
    } else {
      setConfig({ nome: "geral", configuracoes: { interval: value } });
    }
    setChanges(true);
    setHasChanges(true);
  };

  // Add handler for timezone change
  const handleTimezoneChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = event.target.value;
    setTimezone(value);
    if (config) {
      setConfig({
        ...config,
        configuracoes: { ...configuracao, timeZone: value },
      });
    } else {
      setConfig({ nome: "geral", configuracoes: { timeZone: value } });
    }
    setHasChanges(true);
  };

  return (
    <>
      <Stack sx={{ ...styles.boxOP, px: 0 }}>
        <Stack direction="column">
          <Typography sx={styles.text}>Período de coleta</Typography>
          <Typography sx={styles.textFine}>
            Informe o intervalo de tempo máximo disponível para coleta a partir
            do dia atual
          </Typography>
          <Stack justifyContent={"center"} gap={2} mt={1} direction={"row"}>
            <TextField
              fullWidth
              select
              sx={styles.textFieldSelect}
              onChange={handleIntervalChange}
              value={configuracao?.interval ?? 2}
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={styles.textAdorment}>
                        INTERVALO
                      </Typography>
                    </InputAdornment>
                  ),
                },
              }}
            >
              <MenuItem value={2}>2 meses</MenuItem>
              <MenuItem value={3}>3 meses</MenuItem>
            </TextField>
          </Stack>
        </Stack>
        {changes && (
          <Alert sx={{ mt: 1 }} severity="warning">
            <strong>Atenção!</strong> Você alterou o período de coleta do
            EasyReport. É necessário que o período de coleta seja compatível com
            o período de retenção dos dados no Zabbix. Caso tenha dúvidas, entre
            em contato com o suporte para sincronizar a alteração.
          </Alert>
        )}
        <Stack direction="column">
          <Typography sx={styles.text}>Horário local</Typography>
          <Typography sx={styles.textFine}>
            Informe o seu fuso horário para garantir que os horários exibidos
            estejam corretos de acordo com a sua localização.
          </Typography>
          <Stack justifyContent={"center"} gap={2} mt={1} direction={"row"}>
            <TextField
              select
              value={timezone}
              size="small"
              onChange={handleTimezoneChange}
              fullWidth
            >
              {timezones.map((item) => (
                <MenuItem key={item.query} value={item.query}>
                  {item.zona}
                </MenuItem>
              ))}
            </TextField>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
